import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2665920f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "time-slot-time-range" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.timeSlotsList, (timeSlot, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: `time-slot-${i}`,
        class: _normalizeClass(["time-slot-time-range__slot", {
                'slot--main': _ctx.isMain,
                'slot--disabled': _ctx.isTimeSlotDisabled(timeSlot),
                'slot--reserved': _ctx.isTimeSlotReserved(timeSlot),
                'slot--selected': _ctx.isTimeSlotSelected(timeSlot)
            }]),
        onClick: ($event: any) => (_ctx.onClick(timeSlot))
      }, _toDisplayString(_ctx.getDateHour(timeSlot)), 11, _hoisted_2))
    }), 128))
  ]))
}